import { useCallback } from "react";

import { useAppSelector } from "~/hooks/store";
import { useAppDispatch } from "~/store";
import {
  selectGlobal,
  setGlobalJoinedDaoSubdomains,
  setGlobalMember,
  setGlobalPolicyCodes,
  TGlobal,
} from "~/store/globalSlice";

export const useGlobal = () => {
  const global = useAppSelector(selectGlobal);
  const dispatch = useAppDispatch();

  const setMember = useCallback(
    (payload: TGlobal["member"]) => dispatch(setGlobalMember(payload)),
    [dispatch],
  );

  const setPolicyCodes = useCallback(
    (payload: TGlobal["policyCodes"]) =>
      dispatch(setGlobalPolicyCodes(payload)),
    [dispatch],
  );

  const setJoinedDaoSubdomains = useCallback(
    (payload: TGlobal["joinedDaoSubdomains"]) =>
      dispatch(setGlobalJoinedDaoSubdomains(payload)),
    [dispatch],
  );

  return {
    ...global,
    memberSubscriptionId: global.memberSubscriptionId ?? undefined,
    isWeb3Mode: global.mode === "WEB3",
    setMember,
    setPolicyCodes,
    setJoinedDaoSubdomains,
  };
};

/** @reference https://github.com/marpple/ciety-fe/blob/53fc06e8e2d38d9f2ef0e7137ea6754dd72033b3/src/context/global/index.tsx */
